var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "kol", attrs: { id: "kol" } }, [
    _c("div", { staticClass: "l-center" }, [
      _c("h2", { staticClass: "title" }),
      _c("div", { ref: "swiper", staticClass: "swiper kol-list" }, [
        _c(
          "ul",
          { staticClass: "swiper-wrapper" },
          _vm._l(_vm.kolList, function (item, idx) {
            return _c(
              "li",
              {
                key: idx,
                staticClass: "swiper-slide kol-item",
                style: { "--bg-image": `url(${item.tag})` },
              },
              [
                _c(
                  "div",
                  { staticClass: "kol-name", attrs: { title: item.name } },
                  [
                    _c("div", { staticClass: "kol-avatar" }, [
                      _c("img", { attrs: { src: item.avatar, alt: "" } }),
                    ]),
                    _c(
                      "span",
                      { staticClass: "kol-name__text text-ellipsis" },
                      [_vm._v(_vm._s(item.name))]
                    ),
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "kol-intro", attrs: { title: item.intro } },
                  [_c("span", [_vm._v('"' + _vm._s(item.intro) + '"')])]
                ),
              ]
            )
          }),
          0
        ),
      ]),
    ]),
    _c("div", { staticClass: "swiper-controller" }, [
      _c("div", { ref: "pagination", staticClass: "swiper-pagination" }),
      _c("div", { ref: "prev", staticClass: "swiper-button-prev" }),
      _c("div", { ref: "next", staticClass: "swiper-button-next" }),
    ]),
    _c("div", { ref: "fontScroll", staticClass: "kol-font-scroll" }, [
      _c("div", { staticClass: "modal" }),
      _c(
        "div",
        { staticClass: "kol-font-scroll-text", on: { click: _vm.toJoinCivi } },
        [
          _c(
            "div",
            { staticClass: "kol-font-scroll__inner ff--trajanpro-bold" },
            _vm._l(_vm.$locale.kol.propaganda, function (item, idx) {
              return _c("span", { key: idx }, [_vm._v(_vm._s(item))])
            }),
            0
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }